module.exports = __webpack_public_path__ + "static/media/extension-add-problem-gray.a4d14904.svg";